var map = {
	"./accessibility.svg": 407,
	"./activity.svg": 411,
	"./air-vent.svg": 412,
	"./airplay.svg": 413,
	"./alarm-check.svg": 414,
	"./alarm-clock-off.svg": 415,
	"./alarm-clock.svg": 416,
	"./alarm-minus.svg": 417,
	"./alarm-plus.svg": 418,
	"./album.svg": 419,
	"./alert-circle.svg": 420,
	"./alert-octagon.svg": 421,
	"./alert-triangle.svg": 422,
	"./align-center-horizontal.svg": 423,
	"./align-center-vertical.svg": 424,
	"./align-center.svg": 425,
	"./align-end-horizontal.svg": 426,
	"./align-end-vertical.svg": 427,
	"./align-horizontal-distribute-center.svg": 428,
	"./align-horizontal-distribute-end.svg": 429,
	"./align-horizontal-distribute-start.svg": 430,
	"./align-horizontal-justify-center.svg": 431,
	"./align-horizontal-justify-end.svg": 432,
	"./align-horizontal-justify-start.svg": 433,
	"./align-horizontal-space-around.svg": 434,
	"./align-horizontal-space-between.svg": 435,
	"./align-justify.svg": 436,
	"./align-left.svg": 437,
	"./align-right.svg": 438,
	"./align-start-horizontal.svg": 439,
	"./align-start-vertical.svg": 440,
	"./align-vertical-distribute-center.svg": 441,
	"./align-vertical-distribute-end.svg": 442,
	"./align-vertical-distribute-start.svg": 443,
	"./align-vertical-justify-center.svg": 444,
	"./align-vertical-justify-end.svg": 445,
	"./align-vertical-justify-start.svg": 446,
	"./align-vertical-space-around.svg": 447,
	"./align-vertical-space-between.svg": 448,
	"./anchor.svg": 449,
	"./angry.svg": 450,
	"./annoyed.svg": 451,
	"./aperture.svg": 452,
	"./apple.svg": 453,
	"./archive-restore.svg": 454,
	"./archive.svg": 455,
	"./armchair.svg": 456,
	"./arrow-big-down.svg": 457,
	"./arrow-big-left.svg": 458,
	"./arrow-big-right.svg": 459,
	"./arrow-big-up.svg": 460,
	"./arrow-down-circle.svg": 461,
	"./arrow-down-left.svg": 462,
	"./arrow-down-right.svg": 463,
	"./arrow-down.svg": 464,
	"./arrow-left-circle.svg": 465,
	"./arrow-left-right.svg": 466,
	"./arrow-left.svg": 467,
	"./arrow-right-circle.svg": 468,
	"./arrow-right.svg": 469,
	"./arrow-up-circle.svg": 470,
	"./arrow-up-left.svg": 471,
	"./arrow-up-right.svg": 472,
	"./arrow-up.svg": 473,
	"./asterisk.svg": 474,
	"./at-sign.svg": 475,
	"./award.svg": 476,
	"./axe.svg": 477,
	"./axis-3d.svg": 478,
	"./baby.svg": 479,
	"./backpack.svg": 480,
	"./baggage-claim.svg": 481,
	"./banana.svg": 482,
	"./banknote.svg": 483,
	"./bar-chart-2.svg": 484,
	"./bar-chart-3.svg": 485,
	"./bar-chart-4.svg": 486,
	"./bar-chart-horizontal.svg": 487,
	"./bar-chart.svg": 488,
	"./baseline.svg": 489,
	"./bath.svg": 490,
	"./battery-charging.svg": 491,
	"./battery-full.svg": 492,
	"./battery-low.svg": 493,
	"./battery-medium.svg": 494,
	"./battery.svg": 495,
	"./beaker.svg": 496,
	"./bed-double.svg": 497,
	"./bed-single.svg": 498,
	"./bed.svg": 499,
	"./beer.svg": 500,
	"./bell-minus.svg": 501,
	"./bell-off.svg": 502,
	"./bell-plus.svg": 503,
	"./bell-ring.svg": 504,
	"./bell.svg": 505,
	"./bike.svg": 506,
	"./binary.svg": 507,
	"./bitcoin.svg": 508,
	"./bluetooth-connected.svg": 509,
	"./bluetooth-off.svg": 510,
	"./bluetooth-searching.svg": 511,
	"./bluetooth.svg": 512,
	"./bold.svg": 513,
	"./bomb.svg": 514,
	"./bone.svg": 515,
	"./book-open.svg": 516,
	"./book.svg": 517,
	"./bookmark-minus.svg": 518,
	"./bookmark-plus.svg": 519,
	"./bookmark.svg": 520,
	"./bot.svg": 521,
	"./box-select.svg": 522,
	"./box.svg": 523,
	"./boxes.svg": 524,
	"./briefcase.svg": 525,
	"./brush.svg": 526,
	"./bug.svg": 527,
	"./building-2.svg": 528,
	"./building.svg": 529,
	"./bus.svg": 530,
	"./cake.svg": 531,
	"./calculator.svg": 532,
	"./calendar-check-2.svg": 533,
	"./calendar-check.svg": 534,
	"./calendar-clock.svg": 535,
	"./calendar-days.svg": 536,
	"./calendar-heart.svg": 537,
	"./calendar-minus.svg": 538,
	"./calendar-off.svg": 539,
	"./calendar-plus.svg": 540,
	"./calendar-range.svg": 541,
	"./calendar-search.svg": 542,
	"./calendar-x-2.svg": 543,
	"./calendar-x.svg": 544,
	"./calendar.svg": 545,
	"./camera-off.svg": 546,
	"./camera.svg": 547,
	"./car.svg": 548,
	"./carrot.svg": 549,
	"./cast.svg": 550,
	"./check-circle-2.svg": 551,
	"./check-circle.svg": 552,
	"./check-square.svg": 553,
	"./check.svg": 554,
	"./chef-hat.svg": 555,
	"./cherry.svg": 556,
	"./chevron-down.svg": 557,
	"./chevron-first.svg": 558,
	"./chevron-last.svg": 559,
	"./chevron-left.svg": 560,
	"./chevron-right.svg": 561,
	"./chevron-up.svg": 562,
	"./chevrons-down-up.svg": 563,
	"./chevrons-down.svg": 564,
	"./chevrons-left-right.svg": 565,
	"./chevrons-left.svg": 566,
	"./chevrons-right-left.svg": 567,
	"./chevrons-right.svg": 568,
	"./chevrons-up-down.svg": 569,
	"./chevrons-up.svg": 570,
	"./chrome.svg": 571,
	"./cigarette-off.svg": 572,
	"./cigarette.svg": 573,
	"./circle-dot.svg": 574,
	"./circle-ellipsis.svg": 575,
	"./circle-slashed.svg": 576,
	"./circle.svg": 577,
	"./citrus.svg": 578,
	"./clapperboard.svg": 579,
	"./clipboard-check.svg": 580,
	"./clipboard-copy.svg": 581,
	"./clipboard-edit.svg": 582,
	"./clipboard-list.svg": 583,
	"./clipboard-signature.svg": 584,
	"./clipboard-type.svg": 585,
	"./clipboard-x.svg": 586,
	"./clipboard.svg": 587,
	"./clock-1.svg": 588,
	"./clock-10.svg": 589,
	"./clock-11.svg": 590,
	"./clock-12.svg": 591,
	"./clock-2.svg": 592,
	"./clock-3.svg": 593,
	"./clock-4.svg": 594,
	"./clock-5.svg": 595,
	"./clock-6.svg": 596,
	"./clock-7.svg": 597,
	"./clock-8.svg": 598,
	"./clock-9.svg": 599,
	"./clock.svg": 600,
	"./cloud-cog.svg": 601,
	"./cloud-drizzle.svg": 602,
	"./cloud-fog.svg": 603,
	"./cloud-hail.svg": 604,
	"./cloud-lightning.svg": 605,
	"./cloud-moon-rain.svg": 606,
	"./cloud-moon.svg": 607,
	"./cloud-off.svg": 608,
	"./cloud-rain-wind.svg": 609,
	"./cloud-rain.svg": 610,
	"./cloud-snow.svg": 611,
	"./cloud-sun-rain.svg": 612,
	"./cloud-sun.svg": 613,
	"./cloud.svg": 614,
	"./cloudy.svg": 615,
	"./clover.svg": 616,
	"./code-2.svg": 617,
	"./code.svg": 618,
	"./codepen.svg": 619,
	"./codesandbox.svg": 620,
	"./coffee.svg": 621,
	"./cog.svg": 622,
	"./coins.svg": 623,
	"./columns.svg": 624,
	"./command.svg": 625,
	"./compass.svg": 626,
	"./component.svg": 627,
	"./contact.svg": 628,
	"./contrast.svg": 629,
	"./cookie.svg": 630,
	"./copy.svg": 631,
	"./copyleft.svg": 632,
	"./copyright.svg": 633,
	"./corner-down-left.svg": 634,
	"./corner-down-right.svg": 635,
	"./corner-left-down.svg": 636,
	"./corner-left-up.svg": 637,
	"./corner-right-down.svg": 638,
	"./corner-right-up.svg": 639,
	"./corner-up-left.svg": 640,
	"./corner-up-right.svg": 641,
	"./cpu.svg": 642,
	"./credit-card.svg": 643,
	"./croissant.svg": 644,
	"./crop.svg": 645,
	"./cross.svg": 646,
	"./crosshair.svg": 647,
	"./crown.svg": 648,
	"./cup-soda.svg": 649,
	"./curly-braces.svg": 650,
	"./currency.svg": 651,
	"./database.svg": 652,
	"./delete.svg": 653,
	"./diamond.svg": 654,
	"./dice-1.svg": 655,
	"./dice-2.svg": 656,
	"./dice-3.svg": 657,
	"./dice-4.svg": 658,
	"./dice-5.svg": 659,
	"./dice-6.svg": 660,
	"./dices.svg": 661,
	"./diff.svg": 662,
	"./disc.svg": 663,
	"./divide-circle.svg": 664,
	"./divide-square.svg": 665,
	"./divide.svg": 666,
	"./dollar-sign.svg": 667,
	"./download-cloud.svg": 668,
	"./download.svg": 669,
	"./dribbble.svg": 670,
	"./droplet.svg": 671,
	"./droplets.svg": 672,
	"./drumstick.svg": 673,
	"./dutch-flag.svg": 674,
	"./edit-2.svg": 675,
	"./edit-3.svg": 676,
	"./edit.svg": 677,
	"./egg-fried.svg": 678,
	"./egg.svg": 679,
	"./english-flag.svg": 680,
	"./equal-not.svg": 681,
	"./equal.svg": 682,
	"./eraser.svg": 683,
	"./euro.svg": 684,
	"./expand.svg": 685,
	"./external-link.svg": 686,
	"./eye-off.svg": 687,
	"./eye.svg": 688,
	"./facebook.svg": 689,
	"./factory.svg": 690,
	"./fast-forward.svg": 691,
	"./feather.svg": 692,
	"./figma.svg": 693,
	"./file-archive.svg": 694,
	"./file-audio-2.svg": 695,
	"./file-audio.svg": 696,
	"./file-axis-3d.svg": 697,
	"./file-badge-2.svg": 698,
	"./file-badge.svg": 699,
	"./file-bar-chart-2.svg": 700,
	"./file-bar-chart.svg": 701,
	"./file-box.svg": 702,
	"./file-check-2.svg": 703,
	"./file-check.svg": 704,
	"./file-clock.svg": 705,
	"./file-code.svg": 706,
	"./file-cog-2.svg": 707,
	"./file-cog.svg": 708,
	"./file-diff.svg": 709,
	"./file-digit.svg": 710,
	"./file-down.svg": 711,
	"./file-edit.svg": 712,
	"./file-heart.svg": 713,
	"./file-image.svg": 714,
	"./file-input.svg": 715,
	"./file-json-2.svg": 716,
	"./file-json.svg": 717,
	"./file-key-2.svg": 718,
	"./file-key.svg": 719,
	"./file-line-chart.svg": 720,
	"./file-lock-2.svg": 721,
	"./file-lock.svg": 722,
	"./file-minus-2.svg": 723,
	"./file-minus.svg": 724,
	"./file-output.svg": 725,
	"./file-pie-chart.svg": 726,
	"./file-plus-2.svg": 727,
	"./file-plus.svg": 728,
	"./file-question.svg": 729,
	"./file-scan.svg": 730,
	"./file-search-2.svg": 731,
	"./file-search.svg": 732,
	"./file-signature.svg": 733,
	"./file-spreadsheet.svg": 734,
	"./file-symlink.svg": 735,
	"./file-terminal.svg": 736,
	"./file-text.svg": 737,
	"./file-type-2.svg": 738,
	"./file-type.svg": 739,
	"./file-up.svg": 740,
	"./file-video-2.svg": 741,
	"./file-video.svg": 742,
	"./file-volume-2.svg": 743,
	"./file-volume.svg": 744,
	"./file-warning.svg": 745,
	"./file-x-2.svg": 746,
	"./file-x.svg": 747,
	"./file.svg": 748,
	"./files.svg": 749,
	"./film.svg": 750,
	"./filter.svg": 751,
	"./fingerprint.svg": 752,
	"./flag-off.svg": 753,
	"./flag-triangle-left.svg": 754,
	"./flag-triangle-right.svg": 755,
	"./flag.svg": 756,
	"./flame.svg": 757,
	"./flashlight-off.svg": 758,
	"./flashlight.svg": 759,
	"./flask-conical.svg": 760,
	"./flask-round.svg": 761,
	"./flip-horizontal-2.svg": 762,
	"./flip-horizontal.svg": 763,
	"./flip-vertical-2.svg": 764,
	"./flip-vertical.svg": 765,
	"./flower-2.svg": 766,
	"./flower.svg": 767,
	"./focus.svg": 768,
	"./folder-archive.svg": 769,
	"./folder-check.svg": 770,
	"./folder-clock.svg": 771,
	"./folder-closed.svg": 772,
	"./folder-cog-2.svg": 773,
	"./folder-cog.svg": 774,
	"./folder-down.svg": 775,
	"./folder-edit.svg": 776,
	"./folder-heart.svg": 777,
	"./folder-input.svg": 778,
	"./folder-key.svg": 779,
	"./folder-lock.svg": 780,
	"./folder-minus.svg": 781,
	"./folder-open.svg": 782,
	"./folder-output.svg": 783,
	"./folder-plus.svg": 784,
	"./folder-search-2.svg": 785,
	"./folder-search.svg": 786,
	"./folder-symlink.svg": 787,
	"./folder-tree.svg": 788,
	"./folder-up.svg": 789,
	"./folder-x.svg": 790,
	"./folder.svg": 791,
	"./folders.svg": 792,
	"./form-input.svg": 793,
	"./forward.svg": 794,
	"./frame.svg": 795,
	"./framer.svg": 796,
	"./frown.svg": 797,
	"./fuel.svg": 798,
	"./function-square.svg": 799,
	"./gamepad-2.svg": 800,
	"./gamepad.svg": 801,
	"./gauge.svg": 802,
	"./gavel.svg": 803,
	"./gem.svg": 804,
	"./ghost.svg": 805,
	"./gift.svg": 806,
	"./git-branch-plus.svg": 807,
	"./git-branch.svg": 808,
	"./git-commit.svg": 809,
	"./git-compare.svg": 810,
	"./git-fork.svg": 811,
	"./git-merge.svg": 812,
	"./git-pull-request-closed.svg": 813,
	"./git-pull-request-draft.svg": 814,
	"./git-pull-request.svg": 815,
	"./github.svg": 816,
	"./gitlab.svg": 817,
	"./glass-water.svg": 818,
	"./glasses.svg": 819,
	"./globe-2.svg": 820,
	"./globe.svg": 821,
	"./grab.svg": 822,
	"./graduation-cap.svg": 823,
	"./grape.svg": 824,
	"./grid.svg": 825,
	"./grip-horizontal.svg": 826,
	"./grip-vertical.svg": 827,
	"./hammer.svg": 828,
	"./hand-metal.svg": 829,
	"./hand.svg": 830,
	"./hard-drive.svg": 831,
	"./hard-hat.svg": 832,
	"./hash.svg": 833,
	"./haze.svg": 834,
	"./headphones.svg": 835,
	"./heart-crack.svg": 836,
	"./heart-handshake.svg": 837,
	"./heart-off.svg": 838,
	"./heart-pulse.svg": 839,
	"./heart.svg": 840,
	"./help-circle.svg": 240,
	"./hexagon.svg": 841,
	"./highlighter.svg": 842,
	"./history.svg": 843,
	"./home.svg": 844,
	"./hourglass.svg": 845,
	"./ice-cream.svg": 846,
	"./image-minus.svg": 847,
	"./image-off.svg": 848,
	"./image-plus.svg": 849,
	"./image.svg": 850,
	"./import.svg": 851,
	"./inbox.svg": 852,
	"./indent.svg": 853,
	"./indian-rupee.svg": 854,
	"./infinity.svg": 855,
	"./info.svg": 856,
	"./inspect.svg": 857,
	"./instagram.svg": 858,
	"./italic.svg": 859,
	"./japanese-yen.svg": 860,
	"./joystick.svg": 861,
	"./key.svg": 862,
	"./keyboard.svg": 863,
	"./lamp-ceiling.svg": 864,
	"./lamp-desk.svg": 865,
	"./lamp-floor.svg": 866,
	"./lamp-wall-down.svg": 867,
	"./lamp-wall-up.svg": 868,
	"./lamp.svg": 869,
	"./landmark.svg": 870,
	"./languages.svg": 871,
	"./laptop-2.svg": 872,
	"./laptop.svg": 873,
	"./lasso-select.svg": 874,
	"./lasso.svg": 875,
	"./laugh.svg": 876,
	"./layers.svg": 877,
	"./layout-dashboard.svg": 878,
	"./layout-grid.svg": 879,
	"./layout-list.svg": 880,
	"./layout-template.svg": 881,
	"./layout.svg": 882,
	"./leaf.svg": 883,
	"./library.svg": 884,
	"./life-buoy.svg": 885,
	"./lightbulb-off.svg": 886,
	"./lightbulb.svg": 887,
	"./line-chart.svg": 888,
	"./link-2-off.svg": 889,
	"./link-2.svg": 890,
	"./link.svg": 891,
	"./linkedin.svg": 892,
	"./list-checks.svg": 893,
	"./list-end.svg": 894,
	"./list-minus.svg": 895,
	"./list-music.svg": 896,
	"./list-ordered.svg": 897,
	"./list-plus.svg": 898,
	"./list-start.svg": 899,
	"./list-video.svg": 900,
	"./list-x.svg": 901,
	"./list.svg": 902,
	"./loader-2.svg": 903,
	"./loader.svg": 904,
	"./locate-fixed.svg": 905,
	"./locate-off.svg": 906,
	"./locate.svg": 907,
	"./lock.svg": 908,
	"./log-in.svg": 909,
	"./log-out.svg": 910,
	"./luggage.svg": 911,
	"./magnet.svg": 912,
	"./mail-check.svg": 913,
	"./mail-minus.svg": 914,
	"./mail-open.svg": 915,
	"./mail-plus.svg": 916,
	"./mail-question.svg": 917,
	"./mail-search.svg": 918,
	"./mail-warning.svg": 919,
	"./mail-x.svg": 920,
	"./mail.svg": 921,
	"./mails.svg": 922,
	"./map-pin-off.svg": 923,
	"./map-pin.svg": 924,
	"./map.svg": 925,
	"./martini.svg": 926,
	"./maximize-2.svg": 927,
	"./maximize.svg": 928,
	"./medal.svg": 929,
	"./megaphone-off.svg": 930,
	"./megaphone.svg": 931,
	"./meh.svg": 932,
	"./menu.svg": 933,
	"./message-circle.svg": 934,
	"./message-square.svg": 935,
	"./mic-2.svg": 936,
	"./mic-off.svg": 937,
	"./mic.svg": 938,
	"./microscope.svg": 939,
	"./milestone.svg": 940,
	"./minimize-2.svg": 941,
	"./minimize.svg": 942,
	"./minus-circle.svg": 943,
	"./minus-square.svg": 944,
	"./minus.svg": 945,
	"./monitor-off.svg": 946,
	"./monitor-speaker.svg": 947,
	"./monitor.svg": 948,
	"./moon.svg": 949,
	"./more-horizontal.svg": 950,
	"./more-vertical.svg": 951,
	"./mountain-snow.svg": 952,
	"./mountain.svg": 953,
	"./mouse-pointer-2.svg": 954,
	"./mouse-pointer-click.svg": 955,
	"./mouse-pointer.svg": 956,
	"./mouse.svg": 957,
	"./move-3d.svg": 958,
	"./move-diagonal-2.svg": 959,
	"./move-diagonal.svg": 960,
	"./move-horizontal.svg": 961,
	"./move-vertical.svg": 962,
	"./move.svg": 963,
	"./music-2.svg": 964,
	"./music-3.svg": 965,
	"./music-4.svg": 966,
	"./music.svg": 967,
	"./navigation-2-off.svg": 968,
	"./navigation-2.svg": 969,
	"./navigation-off.svg": 970,
	"./navigation.svg": 971,
	"./network.svg": 972,
	"./newspaper.svg": 973,
	"./octagon.svg": 974,
	"./option.svg": 975,
	"./outdent.svg": 976,
	"./package-2.svg": 977,
	"./package-check.svg": 978,
	"./package-minus.svg": 979,
	"./package-open.svg": 980,
	"./package-plus.svg": 981,
	"./package-search.svg": 982,
	"./package-x.svg": 983,
	"./package.svg": 984,
	"./paint-bucket.svg": 985,
	"./paintbrush-2.svg": 986,
	"./paintbrush.svg": 987,
	"./palette.svg": 988,
	"./palmtree.svg": 989,
	"./paperclip.svg": 990,
	"./party-popper.svg": 991,
	"./pause-circle.svg": 992,
	"./pause-octagon.svg": 993,
	"./pause.svg": 994,
	"./pen-tool.svg": 995,
	"./pencil.svg": 996,
	"./percent.svg": 997,
	"./person-standing.svg": 998,
	"./phone-call.svg": 999,
	"./phone-forwarded.svg": 1000,
	"./phone-incoming.svg": 1001,
	"./phone-missed.svg": 1002,
	"./phone-off.svg": 1003,
	"./phone-outgoing.svg": 1004,
	"./phone.svg": 1005,
	"./pie-chart.svg": 1006,
	"./piggy-bank.svg": 1007,
	"./pin-off.svg": 1008,
	"./pin.svg": 1009,
	"./pipette.svg": 1010,
	"./pizza.svg": 1011,
	"./plane.svg": 1012,
	"./play-circle.svg": 1013,
	"./play.svg": 1014,
	"./plug-zap.svg": 1015,
	"./plus-circle.svg": 1016,
	"./plus-square.svg": 1017,
	"./plus.svg": 1018,
	"./pocket.svg": 1019,
	"./podcast.svg": 1020,
	"./pointer.svg": 1021,
	"./pound-sterling.svg": 1022,
	"./power-off.svg": 1023,
	"./power.svg": 1024,
	"./printer.svg": 1025,
	"./puzzle.svg": 1026,
	"./qr-code.svg": 1027,
	"./quote.svg": 1028,
	"./radio-receiver.svg": 1029,
	"./radio.svg": 1030,
	"./recycle.svg": 1031,
	"./redo-2.svg": 1032,
	"./redo.svg": 1033,
	"./refresh-ccw.svg": 1034,
	"./refresh-cw.svg": 1035,
	"./regex.svg": 1036,
	"./repeat-1.svg": 1037,
	"./repeat.svg": 1038,
	"./reply-all.svg": 1039,
	"./reply.svg": 1040,
	"./rewind.svg": 1041,
	"./rocket.svg": 1042,
	"./rocking-chair.svg": 1043,
	"./rotate-3d.svg": 1044,
	"./rotate-ccw.svg": 1045,
	"./rotate-cw.svg": 1046,
	"./rss.svg": 1047,
	"./ruler.svg": 1048,
	"./russian-ruble.svg": 1049,
	"./save.svg": 1050,
	"./scale-3d.svg": 1051,
	"./scale.svg": 1052,
	"./scaling.svg": 1053,
	"./scan-face.svg": 1054,
	"./scan-line.svg": 1055,
	"./scan.svg": 1056,
	"./scissors.svg": 1057,
	"./screen-share-off.svg": 1058,
	"./screen-share.svg": 1059,
	"./scroll.svg": 1060,
	"./search.svg": 1061,
	"./send.svg": 1062,
	"./separator-horizontal.svg": 1063,
	"./separator-vertical.svg": 1064,
	"./server-cog.svg": 1065,
	"./server-crash.svg": 1066,
	"./server-off.svg": 1067,
	"./server.svg": 1068,
	"./settings-2.svg": 1069,
	"./settings.svg": 1070,
	"./share-2.svg": 1071,
	"./share.svg": 1072,
	"./sheet.svg": 1073,
	"./shield-alert.svg": 1074,
	"./shield-check.svg": 1075,
	"./shield-close.svg": 1076,
	"./shield-off.svg": 1077,
	"./shield.svg": 1078,
	"./shirt.svg": 1079,
	"./shopping-bag.svg": 1080,
	"./shopping-cart.svg": 1081,
	"./shovel.svg": 1082,
	"./shrink.svg": 1083,
	"./shrub.svg": 1084,
	"./shuffle.svg": 1085,
	"./sidebar-close.svg": 1086,
	"./sidebar-open.svg": 1087,
	"./sidebar.svg": 1088,
	"./sigma.svg": 1089,
	"./signal-high.svg": 1090,
	"./signal-low.svg": 1091,
	"./signal-medium.svg": 1092,
	"./signal-zero.svg": 1093,
	"./signal.svg": 1094,
	"./siren.svg": 1095,
	"./skip-back.svg": 1096,
	"./skip-forward.svg": 1097,
	"./skull.svg": 1098,
	"./slack.svg": 1099,
	"./slash.svg": 1100,
	"./slice.svg": 1101,
	"./sliders-horizontal.svg": 1102,
	"./sliders.svg": 1103,
	"./smartphone-charging.svg": 1104,
	"./smartphone.svg": 1105,
	"./smile-plus.svg": 1106,
	"./smile.svg": 1107,
	"./snowflake.svg": 1108,
	"./sofa.svg": 1109,
	"./sort-asc.svg": 1110,
	"./sort-desc.svg": 1111,
	"./speaker.svg": 1112,
	"./sprout.svg": 1113,
	"./square.svg": 1114,
	"./star-half.svg": 1115,
	"./star-off.svg": 1116,
	"./star.svg": 1117,
	"./stethoscope.svg": 1118,
	"./sticker.svg": 1119,
	"./sticky-note.svg": 1120,
	"./stop-circle.svg": 1121,
	"./stretch-horizontal.svg": 1122,
	"./stretch-vertical.svg": 1123,
	"./strikethrough.svg": 1124,
	"./subscript.svg": 1125,
	"./sun-dim.svg": 1126,
	"./sun-medium.svg": 1127,
	"./sun-moon.svg": 1128,
	"./sun-snow.svg": 1129,
	"./sun.svg": 1130,
	"./sunrise.svg": 1131,
	"./sunset.svg": 1132,
	"./superscript.svg": 1133,
	"./swiss-franc.svg": 1134,
	"./switch-camera.svg": 1135,
	"./sword.svg": 1136,
	"./swords.svg": 1137,
	"./syringe.svg": 1138,
	"./table-2.svg": 1139,
	"./table.svg": 1140,
	"./tablet.svg": 1141,
	"./tag.svg": 1142,
	"./tags.svg": 1143,
	"./target.svg": 1144,
	"./tent.svg": 1145,
	"./terminal-square.svg": 1146,
	"./terminal.svg": 1147,
	"./text-cursor-input.svg": 1148,
	"./text-cursor.svg": 1149,
	"./thermometer-snowflake.svg": 1150,
	"./thermometer-sun.svg": 1151,
	"./thermometer.svg": 1152,
	"./thumbs-down.svg": 1153,
	"./thumbs-up.svg": 1154,
	"./ticket.svg": 1155,
	"./timer-off.svg": 1156,
	"./timer-reset.svg": 1157,
	"./timer.svg": 1158,
	"./toggle-left.svg": 1159,
	"./toggle-right.svg": 1160,
	"./tool.svg": 1161,
	"./tornado.svg": 1162,
	"./toy-brick.svg": 1163,
	"./train.svg": 1164,
	"./trash-2.svg": 1165,
	"./trash.svg": 1166,
	"./tree-deciduous.svg": 1167,
	"./tree-pine.svg": 1168,
	"./trees.svg": 1169,
	"./trello.svg": 1170,
	"./trending-down.svg": 1171,
	"./trending-up.svg": 1172,
	"./triangle.svg": 1173,
	"./trophy.svg": 1174,
	"./truck.svg": 1175,
	"./tv-2.svg": 1176,
	"./tv.svg": 1177,
	"./twitch.svg": 1178,
	"./twitter.svg": 1179,
	"./type.svg": 1180,
	"./umbrella.svg": 1181,
	"./underline.svg": 1182,
	"./undo-2.svg": 1183,
	"./undo.svg": 1184,
	"./unlink-2.svg": 1185,
	"./unlink.svg": 1186,
	"./unlock.svg": 1187,
	"./upload-cloud.svg": 1188,
	"./upload.svg": 1189,
	"./usb.svg": 1190,
	"./user-check.svg": 1191,
	"./user-cog.svg": 1192,
	"./user-minus.svg": 1193,
	"./user-plus.svg": 1194,
	"./user-x.svg": 1195,
	"./user.svg": 1196,
	"./users.svg": 1197,
	"./utensils-crossed.svg": 1198,
	"./utensils.svg": 1199,
	"./venetian-mask.svg": 1200,
	"./verified.svg": 1201,
	"./vibrate-off.svg": 1202,
	"./vibrate.svg": 1203,
	"./video-off.svg": 1204,
	"./video.svg": 1205,
	"./view.svg": 1206,
	"./voicemail.svg": 1207,
	"./volume-1.svg": 1208,
	"./volume-2.svg": 1209,
	"./volume-x.svg": 1210,
	"./volume.svg": 1211,
	"./wallet.svg": 1212,
	"./wand-2.svg": 1213,
	"./wand.svg": 1214,
	"./watch.svg": 1215,
	"./waves.svg": 1216,
	"./webcam.svg": 1217,
	"./webhook.svg": 1218,
	"./wifi-off.svg": 1219,
	"./wifi.svg": 1220,
	"./wind.svg": 1221,
	"./wine.svg": 1222,
	"./wrap-text.svg": 1223,
	"./wrench.svg": 1224,
	"./x-circle.svg": 1225,
	"./x-octagon.svg": 1226,
	"./x-square.svg": 1227,
	"./x.svg": 1228,
	"./youtube.svg": 1229,
	"./zap-off.svg": 1230,
	"./zap.svg": 1231,
	"./zoom-in.svg": 1232,
	"./zoom-out.svg": 1233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 406;